export default __webpack_public_path__ + "static/media/6.214156c9.jpg";